import {
  Fingerprint,
  BadgeOutlined,
  BusinessOutlined,
  PersonPinOutlined,
  AccountBoxOutlined,
  StorageOutlined,
  DnsOutlined,
  BackupTableOutlined,
  VerifiedUserOutlined
} from '@mui/icons-material';

const seachQuery = [
  {
    value: 'CustomerId',
    text: 'Customer ID',
    boolean: false,
    icon: <Fingerprint color="primary" />,
    color: 'primary.main'
  },
  {
    value: 'CustomerDisplayName',
    text: 'Customer Display Name',
    boolean: false,
    icon: <BadgeOutlined color="secondary" />,
    color: 'secondary.main'
  },
  {
    value: 'OrganizationId',
    text: 'Organization ID',
    boolean: false,
    icon: <BusinessOutlined color="success" />,
    color: 'success.main'
  },
  {
    value: 'OrganizationFriendlyId',
    text: 'Organization FID',
    boolean: false,
    icon: <PersonPinOutlined color="warning" />,
    color: 'warning.main'
  },
  {
    value: 'LicenseAccountName',
    text: 'Account Name',
    boolean: false,
    icon: <AccountBoxOutlined color="info" />,
    color: 'info.main'
  },
  {
    value: 'LicenseAccountId',
    text: 'Account ID',
    boolean: false,
    icon: <VerifiedUserOutlined color="error" />,
    color: 'error.main'
  },
  {
    value: 'CurrentInfraId',
    text: 'Current Infra ID',
    boolean: false,
    icon: <DnsOutlined style={{ color: '#FFC107' }} />,
    color: '#FFC107'
  },
  {
    value: 'SeedPackageVersion',
    text: 'Seed Package Version',
    boolean: false,
    icon: <BackupTableOutlined style={{ color: '#4CAF50' }} />,
    color: '#4CAF50'
  },
  {
    value: 'CurrentPackageVersion',
    text: 'Current Package Version',
    boolean: false,
    icon: <BackupTableOutlined style={{ color: '#2196F3' }} />,
    color: '#2196F3'
  },
  {
    value: 'StorageName',
    text: 'Storage Name',
    boolean: false,
    icon: <StorageOutlined style={{ color: '#9C27B0' }} />,
    color: '#9C27B0'
  },
  {
    value: 'DatabaseName',
    text: 'TIDB Database Name',
    boolean: false,
    icon: <DnsOutlined style={{ color: '#F44336' }} />,
    color: '#F44336'
  }
];

export default seachQuery;
